import { Link, useLocation } from 'react-router-dom';
import {
  getMerchantCatalogueSubnav,
  getMerchantFinanceSubnav,
  getMerchantInventorySubnav,
  getMerchantOrdersSubnav,
  getMerchantReportsSubnav,
  getMerchantSettingsSubnav,
} from './sectionNav.js';
import { isSectionSubnavLinkActive } from './sectionSubnavState.js';
import type { MerchantNavSection } from './merchantNavAccess.js';
import { useBranchIdParam } from '../features/branch-settings/branchSettingsState.js';

/** Section destinations stay reachable on details as well as landing pages. */
export function MerchantSectionLinks({
  section,
  roles,
}: {
  section: MerchantNavSection;
  roles: string[];
}) {
  const { pathname, search } = useLocation();
  const branchId = useBranchIdParam();
  const items =
    section === 'orders'
      ? getMerchantOrdersSubnav(roles)
      : section === 'catalogue'
        ? getMerchantCatalogueSubnav(roles)
        : section === 'inventory'
          ? getMerchantInventorySubnav(roles, branchId)
          : section === 'finance'
            ? getMerchantFinanceSubnav(roles)
            : section === 'reports'
              ? getMerchantReportsSubnav(roles)
              : section === 'settings'
                ? getMerchantSettingsSubnav(roles, branchId)
                : [];
  if (!items.length) return null;
  return (
    <ul className="mer-nav-children">
      {items.map((item) => {
        const active = isSectionSubnavLinkActive(pathname, item.to, search);
        return (
          <li key={item.testId}>
            <Link to={item.to} aria-current={active ? 'page' : undefined}>
              {item.label}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
